import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'
import { Button } from '@pepper/ui'

import AppliedFilterPill from 'components/idea-lab/AppliedFilterPill'

const INTENT_MAP: Record<number, string> = {
  0: 'Commercial',
  1: 'Informational',
  2: 'Navigational',
  3: 'Transactional',
}

type Props = {
  formatTopicsAndKeywordsCount: (value: string) => void
  onClearFilter: (
    value: (
      | 'keyword'
      | 'volume:lte'
      | 'volume:gte'
      | 'difficulty:lte'
      | 'difficulty:gte'
      | 'positionLte'
      | 'positionGte'
      | 'exclude_position'
      | 'intent'
    )[]
  ) => void
}

export const ListFilter = ({
  formatTopicsAndKeywordsCount,
  onClearFilter,
}: Props) => {
  const [queryParams] = useQueryParams({
    keyword: withDefault(StringParam, undefined),
    intent: withDefault(NumberParam, undefined),
    'volume:lte': withDefault(NumberParam, undefined),
    'volume:gte': withDefault(NumberParam, undefined),
    'difficulty:lte': withDefault(NumberParam, undefined),
    'difficulty:gte': withDefault(NumberParam, undefined),
    theme_id: withDefault(StringParam, undefined),
    positionLte: withDefault(NumberParam, undefined),
    positionGte: withDefault(NumberParam, undefined),
    exclude_position: withDefault(BooleanParam, false),
  })

  return (
    <>
      {queryParams.keyword && (
        <AppliedFilterPill
          label={`Inc. Keywords: ${formatTopicsAndKeywordsCount(
            queryParams.keyword
          )}`}
          onClear={() => onClearFilter(['keyword'])}
        />
      )}

      {(queryParams['volume:gte'] || queryParams['volume:lte']) && (
        <AppliedFilterPill
          label={`Vol: ${queryParams['volume:gte']}+`}
          onClear={() => onClearFilter(['volume:gte', 'volume:lte'])}
        />
      )}

      {(queryParams['difficulty:gte'] || queryParams['difficulty:lte']) && (
        <AppliedFilterPill
          label={`KD%: ${queryParams['difficulty:gte'] ?? 0} - ${
            queryParams['difficulty:lte']
          }%`}
          onClear={() => onClearFilter(['difficulty:gte', 'difficulty:lte'])}
        />
      )}

      {queryParams.intent !== undefined && (
        <AppliedFilterPill
          label={`Intent: ${INTENT_MAP[queryParams.intent]}`}
          onClear={() => onClearFilter(['intent'])}
        />
      )}

      {queryParams?.positionLte && queryParams.positionGte && (
        <AppliedFilterPill
          label={`Pos: ${queryParams.positionGte} - ${queryParams.positionLte}`}
          onClear={() =>
            onClearFilter(['positionLte', 'positionGte', 'exclude_position'])
          }
        />
      )}

      {queryParams.exclude_position &&
        !queryParams?.positionGte &&
        !queryParams.positionLte && (
          <AppliedFilterPill
            label="Exclude positions"
            onClear={() =>
              onClearFilter(['positionLte', 'positionGte', 'exclude_position'])
            }
          />
        )}
      <Button
        type="link"
        onClick={() =>
          onClearFilter([
            'keyword',
            'intent',
            'exclude_position',
            'positionGte',
            'positionLte',
            'volume:lte',
            'volume:gte',
            'difficulty:lte',
            'difficulty:gte',
          ])
        }
      >
        Clear Filter
      </Button>
    </>
  )
}
